import { render } from "./HorseHistoryChangesDataTable.vue?vue&type=template&id=a3fc42a4"
import script from "./HorseHistoryChangesDataTable.vue?vue&type=script&lang=js"
export * from "./HorseHistoryChangesDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__